module.exports = __webpack_public_path__ + "img/expand.107ac1d6.svg";